export default "__VITE_ASSET__DDlDZlJm__"